import Vue from 'vue'
import Router from 'vue-router'
// import Hello from '@/components/Hello'
import PriceTable from '@/components/PriceTable'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Hello',
      component: PriceTable
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js